window.addEventListener(
  "DOMContentLoaded",
  function () {
    const displayQustionBlock = document.getElementById("displayQuestions");
    // console.log(displayQustionBlock);

    function getQueryParam(param) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }

    var appid = getQueryParam("appid");
    var userid = getQueryParam("userid");
    if (!appid) {
      var appid = "demo";
      var userid = "demo";
    }

    var hostname = window.location.hostname;

    function setCookie(name, value, days) {
      let cookieString = name + "=" + encodeURIComponent(value) + ";";
      if (days) {
        let expirationDate = new Date();
        expirationDate.setTime(
          expirationDate.getTime() + days * 24 * 60 * 60 * 1000
        ); //one day

        cookieString += "expires=" + expirationDate.toUTCString() + ";";
      }
      cookieString += "path=/;";
      cookieString += "domain=" + hostname + ";";
      cookieString += "secure=true;"; // true on production
      cookieString += "samesite=Lax;";
      document.cookie = cookieString;
    }

    // setCookie("appid", appid, 1);
    // setCookie("userid", userid, 1);
    // setCookie("msisdn", userid, 1);

    function getCookieValue(key) {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(key + "=")) {
          return cookie.substring(key.length + 1);
        }
      }
      return null;
    }
    //spa_question start
    let score = 0;
    let answeredCount = 0;
    let questions = []; // To store fetched questions
    let correctAnswerCount = 0;

    const quizContainer = document.getElementById("displayQuestions");
    const yourScoreBox = document.getElementById("yourscore");
    const totalPointBox = document.getElementById("totalPoint");
    const questAnsweredBox = document.getElementById("questAnswered");

    const questCorrectAnsweredBox = document.getElementById(
      "questCorrectAnswered"
    );
    let thanksMsg = document.getElementById("thanksMsg");

    // Show the result container
    const resultcontainer = document.getElementById("resultcontainer");

    var resultMsgHtml = `<p class="result-message-line thanks_msg" >कोशिश बढ़िया रही...</p>
        <p class="result-message-line result_description" >
          अगली बार आप बेहतर कर सकते हैं.
        </p>
        <p class="result-message-line result_description"  >
          अगले सप्ताह मिलेगी नई क्विज़.
        </p>
        <p class="hasTag">
          #NDTVQuizGame को फ़ॉलो करें और कोई भी पल न चूकें।
        </p>`;

    let resultMsgBox = document.getElementById("resultMsg");

    resultMsgBox.innerHTML = resultMsgHtml;
    // questAnswered

    let totalQuestion = "";
    // document.getElementById("spa_question").innerHTML = "Loading...";

    var startDate = getQueryParam("startDate");
    var endDate = getQueryParam("endDate");
    var category = getQueryParam("category");

    if (startDate !== null && endDate !== null && category !== null) {
      var questionUrl =
        "https://mtech.graphity.in/cms/api/quiz/ndtv?category=" +
        category +
        "&lang=hindi&size=7&startDate=" +
        startDate +
        "&endDate=" +
        endDate;
    } else if (startDate !== null && endDate !== null) {
      var questionUrl =
        "https://mtech.graphity.in/cms/api/quiz/ndtv?category=quiz&lang=hindi&size=7&startDate=" +
        startDate +
        "&endDate=" +
        endDate;
    } else {
      // var questionUrl = "./data.json";
      var questionUrl =
        "https://mtech.graphity.in/cms/api/quiz/ndtv?category=quiz&lang=hindi&size=7";
    }

    function fetchQuestions() {
      fetch(questionUrl)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          questions = data;

          totalQuestion = questions.length;

          // console.log(questions);

          let shuffled = questions
            .map((value) => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);

          // console.log(shuffled);

          questions = shuffled;

          // document.getElementById("spa_ques_count").innerHTML = totalQuestion;
          // document.getElementById("totalqustion_probar").innerHTML = totalQuestion;

          displayQuestions(questions);
        });
    }
    function displayQuestions(questions) {
      quizContainer.innerHTML = ""; // Clear the container

      questions.forEach((question, index) => {
        let imagePath = question.image;
        let readMoreLink = question.url;
        let descriptionText = question.toolTip;

        if (imagePath === null || imagePath === undefined || imagePath === "") {
          imagePath = "./src/img/img1.png";
        }

        if (
          readMoreLink === null ||
          readMoreLink === undefined ||
          readMoreLink === ""
        ) {
          readMoreLink = "#";
        }

        if (
          descriptionText === null ||
          descriptionText === undefined ||
          descriptionText === ""
        ) {
          descriptionText =
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. ";
        }

        let questionHtml = `
      <div class="quiz-question" id="question-${index + 1}">
        <span class="question-number">Q ${index + 1}/${questions.length}</span>
        <h2 class="question">${question.question}</h2>
        <div class="options">`;

        if (question.optionA) {
          questionHtml += `<button class="option" onclick="checkAnswer(this, '${
            question.correctAnswer === "A"
          }', ${index + 1})">
              ${question.optionA}
            </button>`;
        }

        if (question.optionB) {
          questionHtml += ` <button class="option" onclick="checkAnswer(this, '${
            question.correctAnswer === "B"
          }', ${index + 1})">
            ${question.optionB}
          </button>`;
        }

        if (question.optionC) {
          questionHtml += ` <button class="option" onclick="checkAnswer(this, '${
            question.correctAnswer === "C"
          }', ${index + 1})">
            ${question.optionC}
          </button>`;
        }

        if (question.optionD) {
          questionHtml += `<button class="option" onclick="checkAnswer(this, '${
            question.correctAnswer === "D"
          }', ${index + 1})">
           ${question.optionD}
          </button>`;
        }

        questionHtml += `  </div>
        
      </div>
      <hr class="separator" />
      `;

        quizContainer.insertAdjacentHTML("beforeend", questionHtml);
      });
    }

    function checkAnswer(button, isCorrect, questionNumber) {
      // Disable all buttons in the same question
      const options = button.parentElement.querySelectorAll("button");
      options.forEach((option) => {
        option.disabled = true;
      });

      // Add your answer checking logic here
      if (isCorrect === "true") {
        button.classList.add("correct");
        score += 5; // Add 5 points for the correct answer
        correctAnswerCount++;
      } else {
        button.classList.add("incorrect");
      }

      yourScoreBox.innerHTML = score;
      totalPointBox.innerHTML = score;
      // Update the score and answered count
      answeredCount++;
      questAnsweredBox.innerText = answeredCount;

      // Show the info container
      // const infoContainer = button
      //   .closest(".quiz-question")
      //   .querySelector(".info-container");
      // infoContainer.style.display = "block";

      if (questions.length == answeredCount) {
        resultcontainer.style.display = "block";
        questCorrectAnsweredBox.innerHTML = correctAnswerCount;
      }

      if (score >= 0 && score <= 10) {
        var resultMsgHtml = `<p class="result-message-line result_description" >
          एक बार फिर प्रयास करें...
        </p>
        <p class="result-message-line result_description" >
          या खेलें अगली क्विज़...
        </p>
        <p class="hasTag">
          #NDTVQuizGame को फ़ॉलो करें, और खुद को साबित करने का कोई मौका न चूकें...
        </p>`;
        resultMsgBox.innerHTML = resultMsgHtml;
        thanksMsg.innerHTML =
          "हिन्दी भाषा में परिश्रम, यानी मेहनत की आवश्यकता, यानी ज़रूरत है...";
      } else if (score == totalQuestion * 5) {
        var resultMsgHtml = `<p class="result-message-line result_description" >
      अब खेलें अगली क्विज़...
    </p>
    
    <p class="hasTag">
       #NDTVQuizGame को फ़ॉलो करें, और खुद को साबित करने का कोई मौका न चूकें...
    </p>`;

        resultMsgBox.innerHTML = resultMsgHtml;
        thanksMsg.innerHTML = "बस, आप ही हैं हमारे भाषा विद्वान...";
      } else if (score >= 15 && score <= 30) {
        var resultMsgHtml = `<p class="result-message-line result_description"   >
      एक बार फिर प्रयास करें...
    </p>
    <p class="result-message-line result_description" >
       या खेलें अगली क्विज़...
    </p>
    <p class="hasTag">
      #NDTVQuizGame को फ़ॉलो करें, और खुद को साबित करने का कोई मौका न चूकें...
    </p>`;

        resultMsgBox.innerHTML = resultMsgHtml;
        thanksMsg.innerHTML =
          "बस, थोड़ी-सी कसर रह गई... भाषा विद्वान कहलाने के लिए अभी कुछ प्रयास करना होगा...";
      }
    }
    window.checkAnswer = checkAnswer;

    function restartGame() {
      // Reset score and answered count
      score = 0;
      answeredCount = 0;
      correctAnswerCount = 0;

      // Update the display
      yourScoreBox.innerHTML = score;
      totalPointBox.innerHTML = score;

      questAnsweredBox.innerText = answeredCount;

      var resultMsgHtml = `<p class="result-message-line thanks_msg" >कोशिश बढ़िया रही...</p>
  <p class="result-message-line  result_description">
    अगली बार आप बेहतर कर सकते हैं.
  </p>
  <p class="result-message-line result_description">
    अगले सप्ताह मिलेगी नई क्विज़.
  </p>
  <p class="hasTag">
    #NDTVQuizGame को फ़ॉलो करें और कोई भी पल न चूकें।
  </p>`;

      resultMsgBox.innerHTML = resultMsgHtml;

      let shuffled = questions
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);

      // console.log(shuffled);

      questions = shuffled;

      // Redisplay the questions
      displayQuestions(questions);
      resultcontainer.style.display = "none";
    }

    window.restartGame = restartGame;

    fetchQuestions();
  },
  false
);
